import * as util from '../apiUtils';
import * as common from '../apiCommon';
import { PRICEBOOK } from '../../constants/constant_doc_types';
import moment from 'moment';
import { getLocalDateOnly } from '../../utils/local_date';

export function fetchPriceBookById(app, params) {
  const { id } = params;
  const docType = PRICEBOOK;
  return common.getDoc(app, { id, docType }, { assemble_custom_fields: true });
}

export function fetchPriceBooksByReference(app, params) {
  const { searchTerm, searchParams, id, filter, fields } = params;
  const dropdown_type = 'price_book/dropdown';
  const query = {
    fields,
    filter,
    id,
    searchTerm,
    searchParams,
    dropdown_type,
  };

  return common.getDropdownList(app, { query });
}

export function savePriceBook(app, dataToSave) {
  const { user = {}, data, isRenew } = dataToSave;

  let priceBookData = {
    doc_type: PRICEBOOK,
    name: util.toStringText(data.name),
    description: util.toStringText(data.description),
    note: util.toStringText(data.note),
    available_from: getLocalDateOnly(data.available_from),
    available_to: getLocalDateOnly(data.available_to),
    location_id: data.location_id,
    cost_base: data.cost_base,
    mark_up_percent: util.toNumber(data.mark_up_percent),
    margin_percent: util.toNumber(data.margin_percent),
    mark_up_units: util.toNumber(data.markup_units),
    retail_price: data.retail_price,
    floor_price: data.floor_price,
    price_book_reference: util.toStringText(data.price_book_reference),
    price_levels: data.price_levels,
    tax_group_id: data.tax_group_id,
    currency_id: data.currency_id,
    whole_quantity_break: util.toBoolean(data.whole_quantity_break),
    custom_fields: data.custom_fields,
  };

  return common.saveDoc(app, {
    user,
    source: data,
    doc: priceBookData,
    referenceField: !isRenew ? ['price_book_reference'] : [],
    is_renew: isRenew,
    params: {
      assemble_custom_fields: true,
    },
  });
}

export function updatePreviousPriceBookDate(app, dataToSave) {
  const { user = {}, data, previousDate } = dataToSave;
  const id = dataToSave.previousId;
  data.id = id;

  const doc = common.getDoc(app, { id, docType: PRICEBOOK });
  return doc.then((doc) => {
    //if there's no available_to, then use previousDate,
    //else if there's available_to, then do nothing.
    // const hasToDate = doc.available_to;
    // const hasFromDate = doc.available_from;

    // const today = moment().startOf('day');
    // const latestDate = moment(latestToDate).startOf('day');
    // const isPastDate = latestDate.isBefore(today);
    // if(){

    // }
    if (previousDate) {
      doc.available_to = moment(previousDate)
        .endOf('day')
        .utc()
        .format();
    }

    if (moment(doc.available_to).isBefore(moment(doc.available_from))) {
      doc.available_to = doc.available_from;
    }

    return common.saveDoc(
      app,
      {
        source: data,
        doc: doc,
        user,
      },
      PRICEBOOK + '/expire',
    );
  });
}

export function deletePricebook(app, params) {
  const { id } = params;
  return common.deleteDoc(app, {
    id: id,
    docType: PRICEBOOK,
  });
}
